import { CompanyFields } from './company/company-fields.class';
import { CompanyProviders } from './company/company-providers.class';
import { CompanySelectors } from './company/company-selectors.class';
import { CompanyBaskets } from './company/company-baskets.class';
import { Status } from '../enums/status/status.enum';
export class Company {
    disableSelfadjustFinalizing;
    selfadjustEnableReopen;
    hideSelfadjustCancel;
    serviceCode;
    disableReviewSmsNotice;
    selfAdjustStyles;
    reviewSelfadjustAllStatuses;
    caseFields;
    selfadjustInfo;
    costEstimationInfo;
    AI = false;
    estimation = false;
    damageList = false;
    providers;
    selectors;
    fields;
    baskets;
    language;
    disableEditing;
    disableCostEstimationUpdate;
    estimateProvider;
    smartphoto;
    cancellationFields;
    closingFields;
    createFields;
    selfAdjustFields;
    selfadjustInfoFields;
    id;
    costEstimationProvider;
    maxPhoneLength;
    prefixInput;
    selfadjustDisableEditInReopening;
    isBrokers;
    deadlineSelfadjust;
    ownSelfadjusts;
    companyCode;
    labels;
    customLabelSheet;
    partsStaticSelector;
    styles;
    fixedLanguage;
    brokersInfo;
    useConditionsSelfadjust;
    constructor(company) {
        this.id = company.id;
        this.AI = company.enableIA ?? false;
        this.estimation = company.showDamageCostEstimation ?? false;
        this.damageList = company.showDamageSummary ?? false;
        this.providers = new CompanyProviders(company.smartphoto?.partProvider);
        this.selectors = new CompanySelectors(company);
        this.fields = new CompanyFields(company);
        this.baskets = new CompanyBaskets(company.smartphoto?.baskets ?? []);
        this.language = company.fixedLanguage;
        this.disableEditing = company.disableSelfadjustEditing;
        this.disableCostEstimationUpdate = company.disableCostEstimationUpdate;
        this.estimateProvider = company.estimateProvider;
        this.costEstimationInfo = company.costEstimationInfo;
        this.selfadjustInfo = company.selfadjustInfo;
        this.smartphoto = company.smartphoto ?? {};
        this.cancellationFields = company.cancellationFields ?? [];
        this.closingFields = company.closingFields ?? [];
        this.createFields = company.createFields ?? [];
        this.selfAdjustFields = company.selfAdjustFields ?? [];
        this.caseFields = company.caseFields ?? [];
        this.costEstimationProvider = company.costEstimationProvider;
        this.maxPhoneLength = company.maxPhoneLength ?? 15;
        this.prefixInput = company.prefixInput;
        this.selfadjustDisableEditInReopening = company.selfadjustDisableEditInReopening ?? false;
        this.isBrokers = company.isBrokers ?? false;
        this.deadlineSelfadjust = company.deadlineSelfadjust ?? false;
        this.ownSelfadjusts = company.ownSelfadjusts;
        this.companyCode = company.companyCode;
        this.labels = company.labels ?? {};
        this.customLabelSheet = company.customLabelSheet;
        this.partsStaticSelector = company.partsStaticSelector;
        this.styles = company.styles;
        this.fixedLanguage = company.fixedLanguage;
        this.brokersInfo = company.brokersInfo;
        this.disableSelfadjustFinalizing = company.disableSelfadjustFinalizing;
        this.selfadjustEnableReopen = company.selfadjustEnableReopen;
        this.hideSelfadjustCancel = company.hideSelfadjustCancel;
        this.serviceCode = company.service_code;
        this.disableReviewSmsNotice = company.disableReviewSmsNotice;
        this.selfAdjustStyles = company.selfAdjustStyles ?? {};
        this.reviewSelfadjustAllStatuses = company.reviewSelfadjustAllStatuses;
        this.useConditionsSelfadjust = company.useConditionsSelfadjust;
        const pages = Array.isArray(company.selfadjustInfo?.pages)
            ? company.selfadjustInfo.pages
            : Object.values(company.selfadjustInfo?.pages ?? {}).flatMap((template) => template.pages);
        this.selfadjustInfoFields = pages
            .filter((page) => page !== undefined)
            .flatMap((page) => page.selfadjustFields)
            .filter((field) => field !== undefined);
    }
    static fromSmartphotoCompany(smartphotoCompany) {
        return new this({
            ...smartphotoCompany,
            styles: { selfadjust: smartphotoCompany.styles }
        });
    }
    toReview() {
        const { disableSelfadjustFinalizing, selfAdjustStyles = {}, reviewSelfadjustAllStatuses } = this;
        const { selfadjustDisableReview } = selfAdjustStyles ?? {};
        let statuses = [Status.COMPLETED, Status.BODYSHOP_REOPENED];
        if (reviewSelfadjustAllStatuses) {
            statuses = [Status.NEW, Status.IN_PROGRESS, Status.COMPLETED, Status.CANCELLED, Status.REOPENED, Status.BODYSHOP_REOPENED];
        }
        if (disableSelfadjustFinalizing || selfadjustDisableReview) {
            statuses = [];
        }
        return statuses;
    }
    toResend() {
        const { disableReviewSmsNotice, isBrokers } = this;
        let statuses = [Status.NEW, Status.IN_PROGRESS, Status.REVIEWED, Status.REOPENED, Status.BODYSHOP_REOPENED, Status.REPAIRED];
        if (disableReviewSmsNotice) {
            statuses = [Status.NEW, Status.IN_PROGRESS, Status.REOPENED];
        }
        if (isBrokers) {
            statuses = [];
        }
        return statuses;
    }
    toCancel() {
        if (this.disableSelfadjustFinalizing) {
            return [];
        }
        if (this.hideSelfadjustCancel) {
            return [];
        }
        if (['INSUR-MUTUA-AUTOS', 'INSUR-MSANDBOX'].includes(this.serviceCode)) {
            return [Status.NEW, Status.IN_PROGRESS, Status.COMPLETED, Status.REOPENED, Status.REVIEWED];
        }
        return [Status.NEW, Status.IN_PROGRESS, Status.COMPLETED, Status.REOPENED];
    }
    toReopen() {
        if (this.selfadjustEnableReopen) {
            return [Status.COMPLETED, Status.CANCELLED];
        }
        return [];
    }
    toResendBodyShop() {
        if (this.smartphoto?.additionals?.active) {
            return [Status.REVIEWED, Status.BODYSHOP_REOPENED];
        }
        return [];
    }
}
